import SolutionCard from "../../reusables/SolutionCard";
import branding from "../../../assets/images/solutions-icon/branding.svg";

const BrandingSolution = () => {
  return (
    <SolutionCard
      icon={branding}
      title="Branding & Graphic Design"
      subtitle="Professional brand identity setup, logo and visual communication design"
      ctaLink="/solutions/branding-graphic-design"
    />
  );
};

export default BrandingSolution;
